import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import getQueryParams from '@/utils/getQueryParams';
import store from '@/store/BookingStore';
import { createRequestData } from '@/logic/createRequestParams';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { Booking, StatusV2 } from '../../../../../requests-module/src';
import checkIsPackageTrain from '@/logic/options/checkIsPackageTrain';
import {
    saveUrlTokenMapping,
    tryRestoreTokenFromUrlCache,
} from '@/logic/bookingFunnel/bookingFunnelUrlTokenCache';
import { prefillParticipantsFromWidget } from '@/logic/participants/prefillParticipantsFromWidget';

const persistWidgetParticipantsIfNeeded = async (): Promise<void> => {
    try {
        await prefillParticipantsFromWidget()
    } catch (error) {
        console.error('[trainStep] failed to prefill participants from widget', error)
    }
}

export const trainStep = new FunnelStep({
    name: RouteNameEnum.Train,
    dependencies: [],
    init: async () => {
        const queryParams = getQueryParams()

        let response: Booking | { error: string } | null = null
        if (!store.getters.getToken) {
            const restored = tryRestoreTokenFromUrlCache()
            if (restored) {
                console.log('init(): Train Page - restored BO from URL cache, refresh instead of init');
                response = await BookingFunnelService.refreshBookingTrain()
                if ('error' in response) {
                    throw new Error('Error with api')
                }
                saveUrlTokenMapping(window.location.href, response.boReference)

                if (response.status == StatusV2.PROCESSING) {
                    return '/payment'
                }
                if (response.status == StatusV2.SUCCESS) {
                    return '/paid'
                }
                if (!checkIsPackageTrain(response)) {
                    return '/options'
                }
                await persistWidgetParticipantsIfNeeded()
                return false
            }

            console.log('init(): Initializing Train Page - make an init call to get BO with defaults');
            const requestData = createRequestData(queryParams);

            response = await BookingFunnelService.initBookingTrain(requestData)
            if ('error' in response) {
                throw new Error('Error with api')
            }

            store.commit('setToken', response.boReference)
            saveUrlTokenMapping(window.location.href, response.boReference)

        } else {
            console.log('init(): Initializing Train Page - if bo exist, just make a refresh call');
            response = await BookingFunnelService.refreshBookingTrain()
            if ('error' in response) {
                throw new Error('Error with api')
            }
            saveUrlTokenMapping(window.location.href, response.boReference)

            if (response.status == StatusV2.PROCESSING) {
                return '/payment'
            }

            if (response.status == StatusV2.SUCCESS) {
                return '/paid'
            }

            if (!checkIsPackageTrain(response)) {
                return '/options'
            }
        }

        await persistWidgetParticipantsIfNeeded()
        return false
    },

    hasToBeLoggedIn: false
});
